import '../../../styles/pages.css'
import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { Table } from 'shared/ui/Table/Table'
import { getAPIRequest } from 'infrastructure/api'
import { Assignment } from 'infrastructure/api'
import { useNavigateTo } from 'infrastructure/routing'

export function ClassAssignmentList({ classID }: { classID: string | number }) {
  const navigate = useNavigateTo()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [assignments, setAssignments] = useState<Assignment[]>([])

  useEffect(() => {
    if (!classID) return
    const fetchAssignments = async (id: string | number) => {
      setError(null)
      setLoading(true)
      try {
        const res = await getAPIRequest<Assignment[]>(
          `/v1/kat/class/${id}/assignments`,
        )
        if (res) {
          setAssignments(res)
        } else {
          setError((res as any).error || 'Error fetching assignments')
          setAssignments([])
        }
      } catch (e: any) {
        setError(e?.message || 'Error fetching assignments')
        setAssignments([])
      }
      setLoading(false)
    }
    fetchAssignments(classID)
  }, [classID])

  // Table columns for assignments
  const columns = [
    {
      title: <strong>Assignment ID</strong>,
      width: 80,
      rowContent: (a: Assignment) => a.id,
    },
    {
      title: <strong>Name</strong>,
      width: 200,
      rowContent: (a: Assignment) => a.name,
    },
    {
      title: <strong>Due Date</strong>,
      width: 150,
      rowContent: (a: Assignment) => a.due_at,
    },
    {
      title: <strong>Score</strong>,
      width: 80,
      rowContent: (a: Assignment) => a.total_score,
    },
    {
      title: <strong>Type ID</strong>,
      width: 80,
      rowContent: (a: Assignment) => a.type_id,
    },
    {
      title: <strong>Formal</strong>,
      width: 80,
      rowContent: (a: Assignment) => (a.is_formal ? 'Yes' : 'No'),
    },
    {
      title: <strong>Locked</strong>,
      width: 80,
      rowContent: (a: Assignment) => (a.is_locked ? 'Yes' : 'No'),
    },
    {
      title: <strong>Language</strong>,
      width: 50,
      rowContent: (a: Assignment) => a.language,
    },
    {
      title: <strong>Created By UserID</strong>,
      width: 80,
      rowContent: (a: Assignment) => a.created_by_luser_id,
    },
    {
      title: <strong>Created At</strong>,
      width: 150,
      rowContent: (a: Assignment) => a.created_at,
    },
  ]

  return (
    <Box sx={{ mt: 2 }}>
      {error && (
        <Typography color="error" sx={{ mb: 2 }}>
          {error}
        </Typography>
      )}
      {loading && <Typography>Loading assignments...</Typography>}
      {assignments && assignments.length > 0 ? (
        <Table
          title={null}
          columns={columns}
          items={assignments}
          onRowClick={(index: number) => {
            navigate(`/assignmentAttempts?id=${String(assignments[index].id)}`)
          }}
        />
      ) : (
        !loading && !error && <p>No assignments found for this class.</p>
      )}
    </Box>
  )
}
